import { TaskName } from '@/common/constants/taskNames.constants';
import { TaskState } from '@schema';
import i18n from '@/common/i18n';
import type { TaskMap } from '@/common/store/modules/tasks/tasksNotificationMapper';

const showOnTargetGroupChange = (payload) => payload.method !== 'detach_volume';

const taskMap: TaskMap = {
  [TaskName.BLOCK_STORAGE_TARGET_GROUP_CREATE]: {
    [TaskState.SUCCESS]: () => ({
      title: i18n.t('Target group created'),
      message: i18n.t('Target group successfully created'),
    }),
    [TaskState.RUNNING]: () => ({
      message: i18n.t('Creating target group...'),
    }),
    [TaskState.FAILED]: ({ error }) => ({
      title: i18n.t('Error creating target group'),
      message: error
    })
  },
  [TaskName.BLOCK_STORAGE_TARGET_GROUP_CHANGE]: {
    [TaskState.SUCCESS]: ({ payload }) => showOnTargetGroupChange(payload) && ({
      title: i18n.t('Target group updated'),
      message: i18n.t('Target group successfully updated'),
    }),
    [TaskState.RUNNING]: ({ payload }) => showOnTargetGroupChange(payload) && ({
      message: i18n.t('Updating target group...'),
    }),
    [TaskState.FAILED]: ({ error, payload }) => showOnTargetGroupChange(payload) && ({
      title: i18n.t('Error updating target group'),
      message: error
    })
  },
  [TaskName.BLOCK_STORAGE_VOLUME_CREATE]: {
    [TaskState.SUCCESS]: () => ({
      title: i18n.t('Block storage volume created'),
      message: i18n.t('Block storage volume successfully created'),
    }),
    [TaskState.RUNNING]: () => ({
      message: i18n.t('Creating block storage volume...'),
    }),
    [TaskState.FAILED]: ({ error }) => ({
      title: i18n.t('Error creating block storage volume'),
      message: error
    })
  },
  [TaskName.BLOCK_STORAGE_VOLUME_CHANGE]: {
    [TaskState.SUCCESS]: () => ({
      title: i18n.t('Block storage volume updated'),
      message: i18n.t('Block storage volume successfully updated'),
    }),
    [TaskState.RUNNING]: () => ({
      message: i18n.t('Updating block storage volume...'),
    }),
    [TaskState.FAILED]: ({ error }) => ({
      title: i18n.t('Error updating block storage volume'),
      message: error
    })
  },
  [TaskName.BLOCK_STORAGE_USER_CREATE]: {
    [TaskState.SUCCESS]: () => ({
      title: i18n.t('Block storage user created'),
      message: 'Block storage user successfully created'
    }),
    [TaskState.RUNNING]: () => ({
      message: i18n.t('Creating block storage user...'),
    }),
    [TaskState.FAILED]: ({ error }) => ({
      title: i18n.t('Error creating block storage user'),
      message: error
    })
  },
  [TaskName.BLOCK_STORAGE_USER_CHANGE]: {
    [TaskState.SUCCESS]: () => ({
      title: i18n.t('Block storage user updated'),
      message: 'Block storage user successfully updated'
    }),
    [TaskState.RUNNING]: () => ({
      message: i18n.t('Updating block storage user...'),
    }),
    [TaskState.FAILED]: ({ error }) => ({
      title: i18n.t('Error updating block storage user'),
      message: error
    })
  }
};

export default taskMap;
